// NOTE: For production, move these to environment variables (.env file)
// Admin email for system-level operations
export const adminEmail = process.env.REACT_APP_ADMIN_EMAIL || 'malindakpt@gmail.com';

// Configuration for top performer month selection
// Use 'current' to show current month's top performer
// Use 'previous' to show previous month's top performer
export const TOP_PERFORMER_MONTH: 'current' | 'previous' = 
  (process.env.REACT_APP_TOP_PERFORMER_MONTH as 'current' | 'previous') || 'previous';

// Temporary password configuration - in production, use secure password generation
export const tempPass = process.env.REACT_APP_TEMP_PASSWORD || '321456';

export const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD || 'admin123';

export const sampleCompanyProfile = 'https://rankme.lk/Companies/5Fp6TgtU8r4Bhfnxjmcw/Branches/4kjYuoPXJL3ER8lUUfbR';

export const qrPdfPoweredByText = process.env.REACT_APP_QR_PDF_POWERED_BY_TEXT || 'Powered by RankMe.lk';
